import { FormikErrors } from 'formik';

export const getInsuredPolicyMedicalRowFieldErrors = (
  formikErrors: FormikErrors<{ insuredPolicyMedicals?: unknown[] }> | undefined,
  rowIndex: number
): Record<string, string> | undefined => {
  if (!formikErrors?.insuredPolicyMedicals) {
    return undefined;
  }

  const rowErrors = formikErrors.insuredPolicyMedicals as unknown;

  if (!Array.isArray(rowErrors)) {
    return undefined;
  }

  const errorObject = rowErrors[rowIndex];

  if (
    !errorObject ||
    typeof errorObject !== 'object' ||
    Array.isArray(errorObject)
  ) {
    return undefined;
  }

  const fieldErrors = Object.entries(errorObject).reduce<Record<string, string>>(
    (acc, [key, value]) => {
      if (typeof value === 'string') {
        acc[key] = value;
      }

      return acc;
    },
    {}
  );

  if (Object.keys(fieldErrors).length === 0) {
    return undefined;
  }

  return fieldErrors;
};
